import { indigo_side_banner, spicejet_side_banner } from "../../../utils/ImagePath";
import IndigoFlightContents from "./IndigoFlightContents";
import SpicejetFlightContents from "./SpicejetFlightContents";

export const airlineAssets = {
    Indigo: {
        slug: "indigo-flight-booking",
        logo: "https://whatthelogo.com/storage/logos/indigo-300433.png",
        sideBanner: indigo_side_banner,
        content: <IndigoFlightContents />,
        alt: "Indigo Airlines",
    },
    SpiceJet: {
        slug: "spicejet-flight-booking",
        logo: "https://play-lh.googleusercontent.com/GpBflSe4aTVUKcoM7xVVk0gVMEETdYF3Y_r5cNuwKDFRjnbCdpxW9m-GtyzFueCR2ODK",
        sideBanner: spicejet_side_banner,
        content: <SpicejetFlightContents />,
        alt: "SpiceJet Airlines",
    },
};